<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <form #irsForm="ngForm">
    <div class="fluid-container">
      <div class="form-group mt-3">
        <label>Indicator</label>
        <input class="form-control" type="text" name="indicator" [(ngModel)]="rowData.INDICATOR"
               (ngModelChange)="validateIndicator()">
        @if (errorIndicator) {
<span class="form-error-container">
          Indicator should be either P(Prod) or T(Test).
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Accepted</label>
        <input class="form-control" type="text" name="accepted" [(ngModel)]="rowData.ACCEPTED"
               (ngModelChange)="validateAccepted()">
        @if (errorAccepted) {
<span class="form-error-container">
          Accepted should be Y or N.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Created TS</label>
        <div class="date-time-row">
          <input class="form-control" type="date" [(ngModel)]="selectedDate" name="start_date"
                 [min]="minDate" [max]="maxDate">
          <input class="form-control" type="time" [ngModel]="selectedTime" (ngModelChange)="onTimeInputChange($event)"
                 name="start_time" step="1" title="HH:mm">
        </div>
      </div>
      <div class="form-group mt-3">
        <label>Acknowledgement</label>
        <textarea class="form-control" name="acknowledgement" [(ngModel)]="rowData.ACKNOWLEDGEMENT" rows="4"></textarea>
      </div>
      <div class="form-group mt-3">
        <label>Submission Receipt</label>
        <textarea class="form-control" name="sub_receipt" [(ngModel)]="rowData.SUBMISSION_RECEIPT" rows="4"></textarea>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="saving || errorIndicator || errorAccepted" (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
